// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-edit-object-dialog .mat-mdc-tab-header {
  border: none;
}
.fi-edit-object-dialog .mat-mdc-tab-header .mat-mdc-tab .mdc-tab-indicator .mdc-tab-indicator__content--underline {
  border-top-width: 2px;
}
.fi-edit-object-dialog .content-container .featured-image-editor-container {
  height: 200px;
  border-radius: 10px;
  background-size: cover;
}
.fi-edit-object-dialog .content-container .featured-image-editor-container .no-image-icon {
  color: var(--fi-color-light);
  font-size: 112px;
  height: 200px;
  width: 112px;
  line-height: 200px;
  margin: auto;
  display: block;
}
.fi-edit-object-dialog .content-container .featured-image-editor-container .featured-image-edit-menu-trigger {
  position: absolute;
  top: 20px;
  right: 20px;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  min-width: 40px;
  padding: 0;
}
.fi-edit-object-dialog .content-container .featured-image-editor-container .featured-image-edit-menu-trigger .mat-icon {
  line-height: 40px;
  height: 100%;
  width: 100%;
  margin: 0;
  font-size: 16px;
}
.fi-edit-object-dialog .content-container .mat-mdc-form-field.full-width {
  width: 100%;
  margin-top: 20px;
}
.fi-edit-object-dialog .color-palette-container {
  max-width: 500px;
  margin-top: 20px;
}
.fi-edit-object-dialog .color-palette-container .selected-color-preview {
  max-width: 250px;
}

.featured-image-mat-menu .mat-icon {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-edit-object-dialog/fi-edit-object-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AACQ;EACI,qBAAA;AACZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AADZ;AAGY;EACI,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADhB;AAIY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAFhB;AAGgB;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AADpB;AAOY;EACI,WAAA;EACA,gBAAA;AALhB;AASI;EACI,gBAAA;EACA,gBAAA;AAPR;AAQQ;EACI,gBAAA;AANZ;;AAYI;EACI,eAAA;AATR","sourcesContent":[".fi-edit-object-dialog {\r\n    .mat-mdc-tab-header {\r\n        border: none;\r\n        .mat-mdc-tab .mdc-tab-indicator .mdc-tab-indicator__content--underline {\r\n            border-top-width: 2px;\r\n        }\r\n    }\r\n    .content-container {\r\n        .featured-image-editor-container {\r\n            height: 200px;\r\n            border-radius: 10px;\r\n            background-size: cover;\r\n\r\n            .no-image-icon {\r\n                color: var(--fi-color-light);\r\n                font-size: 112px;\r\n                height: 200px;\r\n                width: 112px;\r\n                line-height: 200px;\r\n                margin: auto;\r\n                display: block;\r\n            }\r\n\r\n            .featured-image-edit-menu-trigger {\r\n                position: absolute;\r\n                top: 20px;\r\n                right: 20px;\r\n                border-radius: 50%;\r\n                height: 40px;\r\n                width: 40px;\r\n                min-width: 40px;\r\n                padding: 0;\r\n                .mat-icon {\r\n                    line-height: 40px;\r\n                    height: 100%;\r\n                    width: 100%;\r\n                    margin: 0;\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .mat-mdc-form-field {\r\n            &.full-width {\r\n                width: 100%;\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n    }\r\n    .color-palette-container {\r\n        max-width: 500px;\r\n        margin-top: 20px;\r\n        .selected-color-preview {\r\n            max-width: 250px;\r\n        }\r\n    }\r\n}\r\n\r\n.featured-image-mat-menu {\r\n    .mat-icon {\r\n        font-size: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
